import { render, staticRenderFns } from "./document.vue?vue&type=template&id=28af4e3a&scoped=true&"
import script from "./document.vue?vue&type=script&lang=ts&"
export * from "./document.vue?vue&type=script&lang=ts&"
import style0 from "./document.vue?vue&type=style&index=0&id=28af4e3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28af4e3a",
  null
  
)

export default component.exports